export const initProfileViewedCookie = () => {
    const profile = document.getElementById("profile");
    if (!profile) {
        return;
    }
    /**
     * Track how many profiles a user has viewed.
     * This way inside the profile HTML we can decide to show a dialog to signup or not.
     */
    const hostnameBase = window.location.hostname.replace(/^[^.]*./, "");
    // Check if test cookie is already set
    let profilesViewed = document.cookie
        .split("; ")
        .find((row) => row.startsWith("profiles_viewed="))
        ?.split("=")[1];
    /**
     * Increase profilesViewed with 1
     * Convert to integer and handle null/undefined case
     */
    let viewedCount = 1;
    if (profilesViewed) {
        viewedCount = parseInt(profilesViewed) + 1;
    }
    profilesViewed = viewedCount.toString();
    document.cookie =
        "profiles_viewed=" +
            profilesViewed +
            "; max-age=604800; path=/; domain=" +
            hostnameBase +
            "; secure; samesite=lax";
};
